/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_Bulk_Tag_Menu_HeadingInputs */



/**
* | output |
* | --- |
* | "Apply tag to selected" |
*
* @param {Projects_Bulk_Tag_Menu_HeadingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const projects_bulk_tag_menu_heading = /** @type {((inputs?: Projects_Bulk_Tag_Menu_HeadingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_Bulk_Tag_Menu_HeadingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Tag auf Auswahl anwenden")
	return /** @type {LocalizedString} */ ("Apply tag to selected")
});